import React from "react"
import {Modal} from "antd"
import {useTranslation} from "react-i18next";

/**
 * Универсальная модалка “Как это работает”.
 *
 * Props:
 * - open: boolean
 * - onClose: () => void                // закрыть модалку
 * - onGo?: () => void                  // действие по OK (например, navigate("/how-to-work"))
 * - rememberKey?: string               // если задан, ставит localStorage[rememberKey] = "true" при OK/Cancel
 * - title?: string
 * - text?: React.ReactNode
 * - okText?: string
 * - cancelText?: string
 */

const WelcomeTutorialModal = ({
                                  open,
                                  onClose,
                                  onGo,
                                  rememberKey,
                                  title,
                                  text,
                                  okText,
                                  cancelText,
                              }) => {
    const {t} = useTranslation();

    const handleOk = () => {
        onGo?.()
        onClose?.()
    }

    const handleCancel = () => {
        onClose?.()
    }

    return (
        <Modal
        open={open}
        title={title ?? t("signin.welcomeModalTitle")}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={okText ?? t("signin.welcomeModalOkBtn")}
        cancelText={cancelText ?? t("signin.welcomeModalCancelBtn")}>
            {text ?? t("signin.welcomeModalText")}
        </Modal>
    );
};

export default WelcomeTutorialModal;